import { Typography } from "@mui/material";

interface JiraFormattedDestinationProps {
  projectKey: string;
  projectTitle: string;
}

export const JiraFormattedDestination = ({
  projectKey,
  projectTitle,
}: JiraFormattedDestinationProps) => {
  return (
    <Typography>
      {projectTitle}{" "}
      <Typography component="span" variant="caption" color="text.secondary">
        ({projectKey})
      </Typography>
    </Typography>
  );
};
